/**
 * Kurdish (Sorani) for the app, keyed by the Arabic text: t('عربي', 'English') shows KU['عربي'] when
 * the app is in Kurdish, and Arabic when a text isn't here yet (Sorani readers read Arabic script).
 * Server messages (always Arabic) use the same table through fromServer().
 * Texts with values in them pass their Kurdish as t()'s third argument instead.
 */
export const KU: Record<string, string> = {
  // ---- App screens ----
  'آخر الحركات': 'دوایین جووڵەکان',
  'أجرة الإرجاع': 'کرێی گەڕاندنەوە',
  'أجرة الإرجاع التي تأخذها الشركة (0 إن لم توجد)': 'ئەو کرێی گەڕاندنەوەیەی کۆمپانیاکە وەریدەگرێت (0 ئەگەر نییە)',
  'أجرة الشركة': 'کرێی کۆمپانیا',
  'أجرة الشركة على هذا الطلب': 'کرێی کۆمپانیا بۆ ئەم داواکارییە',
  'أجرة الشركة علينا': 'کرێی کۆمپانیا لەسەر ئێمە',
  'أجور': 'کرێکان',
  'أجور الشحن لك: تحتفظ بها وتسلّم قيمة المواد فقط.': 'کرێی گەیاندن هی خۆتە: لای خۆتی دەهێڵیتەوە و تەنها نرخی کاڵاکان ڕادەستدەکەیت.',
  'أجور الشحن معك': 'کرێی گەیاندن لای تۆیە',
  'أجور الشحن: تُدفع للسائقين لاحقاً': 'کرێی گەیاندن: دواتر بە شۆفێران دەدرێت',
  'أجور الشحن: يأخذها السائق فوراً': 'کرێی گەیاندن: شۆفێر یەکسەر وەریدەگرێت',
  'أجور شحن مستحقة لك': 'کرێی گەیاندنی شایستەی تۆ',
  'أجور شحنك': 'کرێی گەیاندنەکەت',
  'أحددها بنفسي': 'خۆم دیاریدەکەم',
  'أدخل اسم المستخدم وكلمة المرور': 'ناوی بەکارهێنەر و وشەی نهێنی بنووسە',
  'أضف منتجات ليظهر المجموع': 'بەرهەم زیاد بکە بۆ ئەوەی کۆی گشتی دەربکەوێت',
  'أهلاً بك': 'بەخێربێیت',
  'إخفاء المسار': 'شاردنەوەی ڕێگا',
  'إخفاء كلمة المرور': 'شاردنەوەی وشەی نهێنی',
  'إدارة حسابات الموظفين': 'بەڕێوەبردنی هەژماری فەرمانبەران',
  'إرسال الطلب': 'ناردنی داواکاری',
  'إرسال موقع السائق كل (ثانية) — من 10 إلى 300': 'ناردنی شوێنی شۆفێر هەر (چرکە) — لە 10 تا 300',
  'إضافة': 'زیادکردن',
  'إضافة شركة شحن': 'زیادکردنی کۆمپانیای گەیاندن',
  'إظهار الملخص': 'پیشاندانی پوختە',
  'إظهار كلمة المرور': 'پیشاندانی وشەی نهێنی',
  'إعدادات التطبيق': 'ڕێکخستنەکانی ئەپ',
  'إلغاء': 'پاشگەزبوونەوە',
  'إنشاء الطلب': 'دروستکردنی داواکاری',
  'ابحث باسم المنتج أو الرمز': 'بە ناوی بەرهەم یان کۆد بگەڕێ',
  'ابدأ من الآن (تجاهل الطلبات الموجودة حالياً)': 'لە ئێستاوە دەست پێبکە (داواکارییە ئێستاکان پشتگوێ بخە)',
  'ابدأ من صلاحيات الوظيفة': 'لە دەسەڵاتەکانی پیشەکەوە دەست پێبکە',
  'اترك السعر فارغاً للمحافظات التي لا تغطيها الشركة. الأجرة فارغة = مثل السعر. أسعار المناطق تُعدّل من الداشبورد.':
    'نرخ بەتاڵ بهێڵەوە بۆ ئەو پارێزگایانەی کۆمپانیاکە نایانگرێتەوە. کرێی بەتاڵ = هەمان نرخ. نرخی ناوچەکان لە داشبۆردەوە دەگۆڕدرێن.',
  'اتصال': 'پەیوەندی',
  'اختر "السماح طوال الوقت" للموقع حتى يعمل التتبع والتطبيق في الخلفية': '"هەمیشە ڕێگەبدە" هەڵبژێرە بۆ شوێن، تا بەدواداچوون کار بکات کاتێک ئەپەکە لە پشتەوەیە',
  'اختر المحافظة': 'پارێزگا هەڵبژێرە',
  'اختر المحافظة أولاً': 'سەرەتا پارێزگا هەڵبژێرە',
  'اختر المنطقة لتظهر أجور التوصيل': 'ناوچە هەڵبژێرە بۆ ئەوەی کرێی گەیاندن دەربکەوێت',
  'اختر منطقة الزبون': 'ناوچەی کڕیار هەڵبژێرە',
  'اختيار الموقع': 'هەڵبژاردنی شوێن',
  'اختياري، لكن بدونه ما يطلع رمز الموقع على الفاتورة': 'ئارەزوومەندانەیە، بەڵام بەبێ ئەو کۆدی شوێن لەسەر پسوولە دەرناکەوێت',
  'اسم الزبون': 'ناوی کڕیار',
  'اسم الشركة *': 'ناوی کۆمپانیا *',
  'اسم العائلة': 'ناوی خێزان',
  'اسم المستخدم': 'ناوی بەکارهێنەر',
  'اسم المستخدم (حروف إنكليزية صغيرة، أو بريد إلكتروني)': 'ناوی بەکارهێنەر (پیتی بچووکی ئینگلیزی، یان ئیمەیڵ)',
  'اسمح للتطبيق بالوصول إلى الموقع حتى تعرف الإدارة مكان التوصيل': 'ڕێگە بە ئەپەکە بدە دەستی بگات بە شوێن، تا بەڕێوەبەرایەتی شوێنی گەیاندن بزانێت',
  'اضغط على منتج لإضافته': 'کرتە لە بەرهەمێک بکە بۆ زیادکردنی',
  'اقتراح كلمة مرور': 'پێشنیاری وشەی نهێنی',
  'الآن': 'ئێستا',
  'الأجرة': 'کرێ',
  'الأقل ضغطاً': 'کەمترین کار',
  'الأمر سري، لا تشاركه.': 'ئەم فەرمانە نهێنییە، بڵاوی مەکەرەوە.',
  'الإجراء': 'کردار',
  'الإشعارات': 'ئاگادارکردنەوەکان',
  'الإشعارات مفعّلة على هذا الجهاز: طلب جديد بمرحلتك، وطلب متأخر.': 'ئاگادارکردنەوەکان لەسەر ئەم ئامێرە چالاکن: داواکاری نوێ لە قۆناغەکەت، و داواکاری دواکەوتوو.',
  'الإشعارات ممنوعة بالمتصفح. اسمح بها من إعدادات الموقع (رمز القفل جنب العنوان) وحدّث الصفحة.':
    'ئاگادارکردنەوەکان لە وێبگەڕدا ڕێگەپێنەدراون. لە ڕێکخستنی ماڵپەڕەکە ڕێگەیان پێبدە (هێمای قفڵ لای ناونیشان) و پەڕەکە نوێ بکەرەوە.',
  'الإصدار': 'وەشان',
  'الاسم': 'ناو',
  'الاسم الأول *': 'ناوی یەکەم *',
  'الاسم الكامل': 'ناوی تەواو',
  'التتبّع والطلبات': 'بەدواداچوون و داواکارییەکان',
  'التسديد': 'پارەدانەوە',
  'التغيير يطبّق على الطلبات التي لم يستلمها المحصّل بعد.': 'گۆڕانکارییەکە لەسەر ئەو داواکارییانە جێبەجێ دەبێت کە هێشتا کۆکەرەوە وەرینەگرتوون.',
  'التوصيل': 'گەیاندن',
  'التوصيل المتوقع': 'گەیاندنی چاوەڕوانکراو',
  'الحالي': 'ئێستایی',
  'الحساب': 'ژمێریاری',
  'تُنشأ الحسابات من صفحة الموظفين فقط': 'هەژمارەکان تەنها لە پەڕەی فەرمانبەرانەوە دروست دەکرێن',
  'الخريطة': 'نەخشە',
  'الخصم': 'داشکاندن',
  'الرمز': 'کۆد',
  'الزبون': 'کڕیار',
  'السائق': 'شۆفێر',
  'السبب': 'هۆکار',
  'السعر': 'نرخ',
  'السعر على الزبون': 'نرخ لەسەر کڕیار',
  'الشحن': 'گەیاندن',
  'الشحن المجاني لكل المحافظات مفعّل الآن': 'گەیاندنی بێبەرامبەر بۆ هەموو پارێزگاکان ئێستا چالاکە',
  'الصلاحيات': 'دەسەڵاتەکان',
  'الطلب': 'داواکاری',
  'الطلب غير موجود أو ليس من صلاحيتك': 'داواکارییەکە بوونی نییە یان لە دەسەڵاتی تۆدا نییە',
  'الطلبات': 'داواکارییەکان',
  'التحليلات': 'شیکارییەکان',
  'الطلبات بكشف الشركة': 'داواکارییەکانی ناو لیستی کۆمپانیا',
  'العنوان': 'ناونیشان',
  'العنوان (الشارع، أقرب نقطة دالة) *': 'ناونیشان (شەقام، نزیکترین شوێنی ناسراو) *',
  'الفاتورة': 'پسوولە',
  'القبض': 'وەرگرتن',
  'الكل': 'هەموو',
  'اللغة': 'زمان',
  'المبلغ': 'بڕی پارە',
  'المبلغ الذي استلمته الشركة من الزبون': 'ئەو بڕە پارەیەی کۆمپانیاکە لە کڕیاری وەرگرت',
  'المبلغ المدفوع': 'بڕی پارەی دراو',
  'المبلغ المستلم': 'بڕی پارەی وەرگیراو',
  'المبلغ المستلم فعلاً من الشركة (سالب إذا دفعنا لها)': 'ئەو پارەیەی بەڕاستی لە کۆمپانیا وەرگیرا (سالب ئەگەر ئێمە پێمان دا)',
  'المبلغ المستلم من الزبون': 'پارەی وەرگیراو لە کڕیار',
  'المبلغ مطابق': 'بڕەکە یەکسانە',
  'المتصفح لا يدعم تحديد الموقع': 'وێبگەڕ پشتگیری دیاریکردنی شوێن ناکات',
  'المتوفر': 'بەردەست',
  'المجموع': 'کۆی گشتی',
  'المحافظات التي يعمل فيها': 'ئەو پارێزگایانەی تێیاندا کار دەکات',
  'المحافظة': 'پارێزگا',
  'المحافظة التي تعمل بها': 'ئەو پارێزگایەی تێیدا کار دەکەیت',
  'المحافظة مقسّمة لمناطق، ولكل منطقة أجور توصيل.': 'پارێزگاکە دابەشکراوە بۆ ناوچە، و هەر ناوچەیەک کرێی گەیاندنی خۆی هەیە.',
  'المحصّل': 'کۆکەرەوە',
  'المراحل التي يعمل فيها': 'ئەو قۆناغانەی تێیاندا کار دەکات',
  'المطلوب من الزبون': 'داواکراو لە کڕیار',
  'المفروض تدفعه الشركة': 'ئەوەی کۆمپانیاکە دەبێت بیدات',
  'المنتجات': 'بەرهەمەکان',
  'المنطقة': 'ناوچە',
  'الموظف الذي لديه طلبات أو مبالغ لا يُحذف حتى يبقى اسمه في السجل، بل يُعطَّل فقط.':
    'ئەو فەرمانبەرەی داواکاری یان پارەی تۆمارکراوی هەیە ناسڕدرێتەوە تا ناوی لە تۆمارەکەدا بمێنێت، تەنها ناچالاک دەکرێت.',
  'الموظفون': 'فەرمانبەران',
  'الموقع': 'ماڵپەڕ',
  'الهاتف': 'تەلەفۆن',
  'الوظيفة (يمكن اختيار أكثر من وظيفة)': 'پیشە (دەتوانیت زیاتر لە یەک هەڵبژێریت)',
  'بانتظار القبض': 'چاوەڕێی وەرگرتن',
  'بدون محافظة': 'بێ پارێزگا',
  'بذمتها': 'لای ئەوە',
  'بعد 3 ساعات': 'دوای 3 کاتژمێر',
  'بعد ساعة': 'دوای کاتژمێرێک',
  'بعد ما تسجّل، الإدارة بتراجع طلبك وبتفعّل حسابك': 'دوای تۆمارکردن، بەڕێوەبەرایەتی داواکارییەکەت پێدادەچێتەوە و هەژمارەکەت چالاک دەکات',
  'يستطيع إدارة حسابات الوظائف المحددة فقط، ولا يستطيع منحها صلاحيات إضافية. الحساب الذي لديه طلبات أو مبالغ لا يُحذف، بل يُعطَّل فقط.':
    'تەنها دەتوانێت هەژماری پیشە دیاریکراوەکان بەڕێوەببات، و ناتوانێت دەسەڵاتی زیادەیان پێبدات. ئەو هەژمارەی داواکاری یان پارەی هەیە ناسڕدرێتەوە، تەنها ناچالاک دەکرێت.',
  'تأكيد': 'دڵنیاکردنەوە',
  'تأكيد التسديد': 'دڵنیاکردنەوەی پارەدانەوە',
  'تأكيد الدفع': 'دڵنیاکردنەوەی پارەدان',
  'تتبع الشحنة': 'بەدواداچوونی بار',
  'تتبّع السائقين': 'بەدواداچوونی شۆفێران',
  'تحويل': 'گواستنەوە',
  'تحويل للكول سنتر': 'ناردن بۆ کۆڵ سەنتەر',
  'تسجيل الخروج': 'چوونەدەرەوە',
  'تسجيل الدخول': 'چوونەژوورەوە',
  'تسجيل السائقين': 'تۆمارکردنی شۆفێران',
  'تسجيل تسديد الشركة': 'تۆمارکردنی پارەدانەوەی کۆمپانیا',
  'تسجيل سائق جديد': 'تۆمارکردنی شۆفێری نوێ',
  'تسديد': 'پارەدانەوە',
  'تسديد خلال': 'پارەدانەوە لە ماوەی',
  'تسديدات سابقة': 'پارەدانەوەکانی پێشوو',
  'تسلّم كامل المبلغ للمحصّل، وتُدفع لك أجور الشحن لاحقاً من الإدارة.': 'هەموو پارەکە ڕادەستی کۆکەرەوە دەکەیت، و کرێی گەیاندنت دواتر لەلایەن بەڕێوەبەرایەتییەوە پێدەدرێت.',
  'تشغيل تلقائي كل 5 دقائق (Cron)': 'کارپێکردنی خۆکار هەر 5 خولەک جارێک (Cron)',
  'تعديل': 'دەستکاریکردن',
  'تعديل شركة الشحن': 'دەستکاریکردنی کۆمپانیای گەیاندن',
  'تغيير المحافظة يحذف المنتجات المضافة، لأن لكل محافظة مخزنها. متابعة؟': 'گۆڕینی پارێزگا بەرهەمە زیادکراوەکان دەسڕێتەوە، چونکە هەر پارێزگایەک کۆگای خۆی هەیە. بەردەوام دەبیت؟',
  'تفعيل الإشعارات': 'چالاککردنی ئاگادارکردنەوەکان',
  'تقدر تسجّل دخول باسم المستخدم وكلمة المرور بعد ما توافق الإدارة على طلبك.': 'دوای ڕەزامەندی بەڕێوەبەرایەتی لەسەر داواکارییەکەت، دەتوانیت بە ناوی بەکارهێنەر و وشەی نهێنی بچیتە ژوورەوە.',
  'تم': 'تەواو',
  'تم إرسال طلبك': 'داواکارییەکەت نێردرا',
  'تم إنشاء الطلب': 'داواکارییەکە دروستکرا',
  'تم النسخ': 'کۆپی کرا',
  'تم حفظ الإعدادات': 'ڕێکخستنەکان پاشەکەوت کران',
  'تم حفظ شركة الشحن': 'کۆمپانیای گەیاندن پاشەکەوت کرا',
  'تم: الطلبات الجديدة فقط من الآن تدخل التطبيق': 'تەواو: لە ئێستاوە تەنها داواکارییە نوێیەکان دێنە ناو ئەپەکە',
  'تمت الفوترة: أؤكد تغيير المبلغ وسأعيد طباعة الفاتورة': 'پسوولە کراوە: گۆڕینی بڕەکە پشتڕاست دەکەمەوە و پسوولەکە دووبارە چاپ دەکەمەوە',
  'توصيل': 'گەیاندن',
  'توصيل خلال': 'گەیاندن لە ماوەی',
  'جارٍ توصيل طلب': 'داواکارییەک لە گەیاندندایە',
  'حالة الشركة': 'دۆخی کۆمپانیا',
  'حالة الطلب عند الشركة': 'دۆخی داواکاری لای کۆمپانیا',
  'حتى تدخل الطلبات وتصل إشعارات التأخير حتى لو لم يكن أحد يفتح التطبيق: في Hostinger افتح Advanced ← Cron Jobs ← Custom، اختر كل 5 دقائق (*/5 * * * *) والصق هذا الأمر:':
    'بۆ ئەوەی داواکارییەکان بێنە ژوورەوە و ئاگادارکردنەوەی دواکەوتن بگات تەنانەت ئەگەر کەس ئەپەکەی نەکردبێتەوە: لە Hostinger بکەرەوە Advanced ← Cron Jobs ← Custom، هەر 5 خولەک هەڵبژێرە (*/5 * * * *) و ئەم فەرمانە دابنێ:',
  'حدث خطأ في الخادم، حاول مرة أخرى': 'هەڵەیەک لە ڕاژەکار ڕوویدا، دووبارە هەوڵبدەرەوە',
  'حدث خطأ، حاول مرة أخرى': 'هەڵەیەک ڕوویدا، دووبارە هەوڵبدەرەوە',
  'حذف': 'سڕینەوە',
  'حذف المنتج': 'سڕینەوەی بەرهەم',
  'حذف مواقع السائقين الأقدم من (يوم)': 'سڕینەوەی شوێنی شۆفێران کە کۆنترن لە (ڕۆژ)',
  'حسب المحافظة': 'بەپێی پارێزگا',
  'حسب الوظيفة (الافتراضي)': 'بەپێی پیشە (بنەڕەت)',
  'حفظ': 'پاشەکەوتکردن',
  'خريطة السائقين': 'نەخشەی شۆفێران',
  'د.ع': 'د.ع',
  'دخل الطلب للتطبيق كطلب وارد، ووصل إشعاره للمدراء والتيلغرام.': 'داواکارییەکە وەک داواکاری هاتوو هاتە ناو ئەپەکە، و ئاگادارکردنەوەکەی گەیشتە بەڕێوەبەران و تێلیگرام.',
  'دفع': 'پارەدان',
  'دقيقة': 'خولەک',
  'رابط التتبع — ضع {code} مكان رقم الوصل': 'بەستەری بەدواداچوون — {code} لە شوێنی ژمارەی پسوولەی گواستنەوە دابنێ',
  'رجوع': 'گەڕانەوە',
  'رجوع لتسجيل الدخول': 'گەڕانەوە بۆ چوونەژوورەوە',
  'رجوع للطلبات': 'گەڕانەوە بۆ داواکارییەکان',
  'رد وأكّد الطلب': 'وەڵامی دایەوە و داواکارییەکەی پشتڕاست کردەوە',
  'رفض': 'ڕەتکردنەوە',
  'رقم الهاتف': 'ژمارەی تەلەفۆن',
  'رقم الهاتف *': 'ژمارەی تەلەفۆن *',
  'رقم الوصل': 'ژمارەی پسوولەی گواستنەوە',
  'رقم الوصل عند الشركة (اختياري، يُضاف لاحقاً)': 'ژمارەی پسوولەی گواستنەوە لای کۆمپانیا (ئارەزوومەندانە، دواتر زیاد دەکرێت)',
  'سائق جديد؟ سجّل حسابك': 'شۆفێری نوێیت؟ هەژمارەکەت تۆمار بکە',
  'سائقينا': 'شۆفێرەکانمان',
  'ساعة': 'کاتژمێر',
  'سبب الإلغاء': 'هۆکاری هەڵوەشاندنەوە',
  'سجل الطلب': 'تۆماری داواکاری',
  'سجّل الدخول باسم المستخدم الذي أعطاك إياه المدير': 'بەو ناوی بەکارهێنەرەی بەڕێوەبەر پێی داویت بچۆ ژوورەوە',
  'سعر الشحن على الزبون': 'نرخی گەیاندن لەسەر کڕیار',
  'سعر ثابت': 'نرخی جێگیر',
  'سلّمها للمحصّل من صفحة كل طلب: "تسليم المبلغ للمحصّل"': 'لە پەڕەی هەر داواکارییەکەوە ڕادەستی کۆکەرەوەی بکە: "ڕادەستکردنی پارە بە کۆکەرەوە"',
  'سيقرأ السيرفر الرابط عند حساب الطلب': 'ڕاژەکار بەستەرەکە دەخوێنێتەوە لە کاتی ژماردنی داواکارییەکەدا',
  'شحن': 'گەیاندن',
  'شركات الشحن': 'کۆمپانیاکانی گەیاندن',
  'شركات الشحن وأسعارها': 'کۆمپانیاکانی گەیاندن و نرخەکانیان',
  'شركة الشحن': 'کۆمپانیای گەیاندن',
  'شركة شحن جديدة': 'کۆمپانیای گەیاندنی نوێ',
  'شعار دواء الحياة': 'لۆگۆی دەوائ الحیاة',
  'صباح الخير': 'بەیانیت باش',
  'صلاحيتك على الإعدادات مشاهدة فقط': 'دەسەڵاتت لەسەر ڕێکخستنەکان تەنها بینینە',
  'طلب': 'داواکاری',
  'طلب التأجيل': 'داوای دواخستنی کرد',
  'طلب جديد': 'داواکاری نوێ',
  'طلب جديد آخر': 'داواکارییەکی نوێی تر',
  'طلب جديد لزبون': 'داواکاری نوێ بۆ کڕیار',
  'طلبات تسجيل بانتظار الموافقة': 'داواکاری تۆمارکردن چاوەڕێی ڕەزامەندین',
  'طلبات لم تسلّم مبلغها بعد': 'داواکارییەک کە هێشتا پارەکەی ڕادەست نەکراوە',
  'طلبات واردة': 'داواکاری هاتوو',
  'طي الملخص': 'داخستنی پوختە',
  'عرض المسار': 'پیشاندانی ڕێگا',
  'على الزبون': 'لەسەر کڕیار',
  'غداً 10 صباحاً': 'سبەی کاتژمێر 10ی بەیانی',
  'فاتورة عربي': 'پسوولەی عەرەبی',
  'فاتورة كردي': 'پسوولەی کوردی',
  'فتح الموقع': 'کردنەوەی شوێن',
  'فرق': 'جیاوازی',
  'فعّل الإشعارات لتصلك الطلبات الجديدة والمتأخرة حتى لو كان التطبيق مغلقاً.': 'ئاگادارکردنەوەکان چالاک بکە تا داواکارییە نوێ و دواکەوتووەکانت پێبگات تەنانەت ئەگەر ئەپەکە داخرابێت.',
  'فوراً': 'یەکسەر',
  'في التوصيل الآن': 'ئێستا لە گەیاندندا',
  'في ذمتك': 'لای تۆیە',
  'في ذمتك الآن': 'ئێستا لای تۆیە',
  'قبض': 'وەرگرتن',
  'قبول وتفعيل': 'قبووڵکردن و چالاککردن',
  'قيد التوصيل': 'لە گەیاندندایە',
  'قيمة المواد': 'نرخی کاڵاکان',
  'كل المحافظات': 'هەموو پارێزگاکان',
  'كل المراحل': 'هەموو قۆناغەکان',
  'كل موظفي الكول سنتر': 'هەموو فەرمانبەرانی کۆڵ سەنتەر',
  'كلمة المرور': 'وشەی نهێنی',
  'كلمة المرور (8 أحرف على الأقل)': 'وشەی نهێنی (لانیکەم 8 پیت)',
  'كلمة مرور جديدة (اتركها فارغة لعدم التغيير)': 'وشەی نهێنی نوێ (بەتاڵی بهێڵەوە بۆ نەگۆڕین)',
  'لا تغطي محافظة هذا الطلب': 'پارێزگای ئەم داواکارییە ناگرێتەوە',
  'لا توجد حركات بعد': 'هێشتا هیچ جووڵەیەک نییە',
  'لا توجد شركات شحن بعد': 'هێشتا هیچ کۆمپانیایەکی گەیاندن نییە',
  'لا توجد شركات شحن مفعّلة (تُضاف من الإعدادات)': 'هیچ کۆمپانیایەکی گەیاندنی چالاک نییە (لە ڕێکخستنەکانەوە زیاد دەکرێن)',
  'لا توجد طلبات بانتظار تسديد هذه الشركة': 'هیچ داواکارییەک چاوەڕێی پارەدانەوەی ئەم کۆمپانیایە نییە',
  'لا توجد طلبات معك الآن': 'ئێستا هیچ داواکارییەک لای تۆ نییە',
  'لا توجد طلبات هنا الآن': 'ئێستا هیچ داواکارییەک لێرە نییە',
  'لا توجد مبالغ مسجلة بعد': 'هێشتا هیچ پارەیەک تۆمار نەکراوە',
  'لا توجد مبالغ معلّقة عندك': 'هیچ پارەیەکی هەڵپەسێردراو لای تۆ نییە',
  'لا توجد منتجات متوفرة بهذا البحث': 'هیچ بەرهەمێکی بەردەست بەم گەڕانە نییە',
  'لا يوجد اتصال بالإنترنت': 'پەیوەندی ئینتەرنێت نییە',
  'لا يوجد سائق في توصيل الآن': 'ئێستا هیچ شۆفێرێک لە گەیاندندا نییە',
  'لا يوجد سائقون مفعّلون': 'هیچ شۆفێرێکی چالاک نییە',
  'لا يوجد موظف كول سنتر لهذه المحافظة': 'هیچ فەرمانبەرێکی کۆڵ سەنتەر بۆ ئەم پارێزگایە نییە',
  'لا يوجد موظفون بهذه الوظيفة': 'هیچ فەرمانبەرێک بەم پیشەیە نییە',
  'لاحقاً': 'دواتر',
  'لتغيير كلمة المرور أو الوظيفة تواصل مع المدير.': 'بۆ گۆڕینی وشەی نهێنی یان پیشە پەیوەندی بە بەڕێوەبەرەوە بکە.',
  'لكل موظفي الكول سنتر': 'بۆ هەموو فەرمانبەرانی کۆڵ سەنتەر',
  'لم يرد': 'وەڵامی نەدایەوە',
  'لم يصل موقع بعد': 'هێشتا هیچ شوێنێک نەگەیشتووە',
  'ليس لديك صلاحية الموافقة': 'دەسەڵاتی ڕەزامەندیت نییە',
  'مبالغ لم تصل للقبض بعد': 'پارە کە هێشتا نەگەیشتووەتە وەرگرتن',
  'متأخر': 'دواکەوتوو',
  'متأخرة': 'دواکەوتوو',
  'متابعة الطلبات': 'بەدواداچوونی داواکارییەکان',
  'متى نعيد الاتصال؟': 'کەی دووبارە پەیوەندی بکەینەوە؟',
  'متى يأخذ السائق أجور الشحن؟': 'شۆفێر کەی کرێی گەیاندن وەردەگرێت؟',
  'مثل السعر': 'هەمان نرخ',
  'مثلاً: في مخزن الشركة، مع المندوب…': 'بۆ نموونە: لە کۆگای کۆمپانیا، لای نوێنەر…',
  'مجاني': 'بێبەرامبەر',
  'محافظات محددة': 'پارێزگای دیاریکراو',
  'محاولات الاتصال': 'هەوڵەکانی پەیوەندی',
  'مختارة، لم يُسلَّم بعد': 'هەڵبژێردراوە، هێشتا ڕادەست نەکراوە',
  'مدة التسديد المتوقعة (يوم)': 'ماوەی چاوەڕوانکراوی پارەدانەوە (ڕۆژ)',
  'مدة التوصيل المتوقعة (ساعة)': 'ماوەی چاوەڕوانکراوی گەیاندن (کاتژمێر)',
  'مدراء الموقع': 'بەڕێوەبەرانی ماڵپەڕ',
  'مدير التطبيق يملك كل الصلاحيات تلقائياً.': 'بەڕێوەبەری ئەپ بە شێوەی خۆکار هەموو دەسەڵاتەکانی هەیە.',
  'مدير الموقع': 'بەڕێوەبەری ماڵپەڕ',
  'مرتجع': 'گەڕاوە',
  'مساء الخير': 'ئێوارەت باش',
  'مساء النور': 'شەوت باش',
  'مستحق له': 'شایستەی ئەوە',
  'مسح': 'سڕینەوە',
  'مسموح': 'ڕێگەپێدراو',
  'مغلق': 'داخراو',
  'مفعّل': 'چالاک',
  'مفعّلة (تظهر عند اختيار شركة الشحن)': 'چالاکە (لە کاتی هەڵبژاردنی کۆمپانیای گەیاندن دەردەکەوێت)',
  'ملاحظات': 'تێبینییەکان',
  'ملاحظة (اختياري)': 'تێبینی (ئارەزوومەندانە)',
  'ملاحظة (رقم الكشف مثلاً)': 'تێبینی (بۆ نموونە ژمارەی لیست)',
  'ملاحظة الزبون': 'تێبینی کڕیار',
  'من محافظة الطلب': 'لە پارێزگای داواکارییەکەوە',
  'منتجات الطلب': 'بەرهەمەکانی داواکاری',
  'مواد': 'کاڵا',
  'موظف الاتصال': 'فەرمانبەری پەیوەندی',
  'موظف جديد': 'فەرمانبەری نوێ',
  'موقع الزبون': 'شوێنی کڕیار',
  'موقعك يُشارك مع الإدارة أثناء التوصيل فقط': 'شوێنەکەت تەنها لە کاتی گەیاندندا لەگەڵ بەڕێوەبەرایەتی هاوبەش دەکرێت',
  'موقوفة': 'ڕاگیراوە',
  'مين يتصل بالزبون؟': 'کێ پەیوەندی بە کڕیارەوە دەکات؟',
  'ناقص': 'کەم',
  'نسخ الأمر': 'کۆپیکردنی فەرمان',
  'نعم، غيّر': 'بەڵێ، بیگۆڕە',
  'هاتف الشركة': 'تەلەفۆنی کۆمپانیا',
  'هذا الجهاز أو المتصفح لا يدعم الإشعارات. على الآيفون: أضف التطبيق للشاشة الرئيسية أولاً.':
    'ئەم ئامێرە یان وێبگەڕە پشتگیری ئاگادارکردنەوە ناکات. لەسەر ئایفۆن: سەرەتا ئەپەکە زیاد بکە بۆ شاشەی سەرەکی.',
  'هذا الطلب شحنه مجاني من الموقع، ويبقى مجانياً مع أي شركة': 'گەیاندنی ئەم داواکارییە لە ماڵپەڕەوە بێبەرامبەرە، و لەگەڵ هەر کۆمپانیایەک بێبەرامبەر دەمێنێتەوە',
  'هذه الصفحة ليست من صلاحيتك': 'ئەم پەڕەیە لە دەسەڵاتی تۆدا نییە',
  'واتساب': 'واتسئاپ',
  'واردة': 'هاتوو',
  'يبقى المبلغ بذمة الشركة لحين تسديدها': 'پارەکە لای کۆمپانیاکە دەمێنێتەوە تا پارەکە دەداتەوە',
  'يحتفظ بأجور الشحن عند التسليم ويسلّم قيمة المواد فقط': 'لە کاتی ڕادەستکردندا کرێی گەیاندن لای خۆی دەهێڵێتەوە و تەنها نرخی کاڵاکان ڕادەست دەکات',
  'يسلّم كل المبلغ، وادمن القبض يدفع له أجوره من صفحة الذمم': 'هەموو پارەکە ڕادەست دەکات، و ئەدمینی وەرگرتن لە پەڕەی پارەکانەوە کرێکەی پێدەدات',
  'يصل للكل، وأول واحد يسجّل نتيجة الاتصال بيستلم الطلب': 'بۆ هەمووان دەچێت، و یەکەم کەس کە ئەنجامی پەیوەندی تۆمار بکات داواکارییەکە وەردەگرێت',
  'يظهر السائق أثناء توصيل طلب فقط · يتحدّث كل 20 ثانية': 'شۆفێر تەنها لە کاتی گەیاندنی داواکارییەکدا دەردەکەوێت · هەر 20 چرکە نوێ دەبێتەوە',
  'يظهر في شاشة الدخول "سائق جديد؟ سجّل حسابك"، ويصل الطلب للموافقة في صفحة الموظفين':
    'لە شاشەی چوونەژوورەوە "شۆفێری نوێیت؟ هەژمارەکەت تۆمار بکە" دەردەکەوێت، و داواکارییەکە بۆ ڕەزامەندی دەچێتە پەڕەی فەرمانبەران',
  'يوم': 'ڕۆژ',
  'يُطبع على الفاتورة كرمز QR ويظهر للسائق، مثل طلبات الموقع. الصق رابط الموقع الذي أرسله الزبون أو اضغط على الخريطة.':
    'وەک کۆدی QR لەسەر پسوولە چاپ دەکرێت و بۆ شۆفێر دەردەکەوێت، وەک داواکارییەکانی ماڵپەڕ. ئەو بەستەری شوێنەی کڕیار ناردوویەتی دابنێ یان کرتە لە نەخشەکە بکە.',

  // ---- Stage / action / role / permission labels ----
  'أعيد فتح الطلب': 'داواکارییەکە دووبارە کرایەوە',
  'إرجاع الطلب لمرحلة سابقة': 'گەڕاندنەوەی داواکاری بۆ قۆناغی پێشوو',
  'إرجاع طلب للفوترة قبل التجهيز': 'گەڕاندنەوەی داواکاری بۆ پسوولەکردن پێش ئامادەکردن',
  'إرجاع لمرحلة سابقة': 'گەڕاندنەوە بۆ قۆناغی پێشوو',
  'إلغاء الطلب': 'هەڵوەشاندنەوەی داواکاری',
  'إلغاء الطلبات': 'هەڵوەشاندنەوەی داواکارییەکان',
  'إنشاء طلب جديد لزبون': 'دروستکردنی داواکاری نوێ بۆ کڕیار',
  'اختيار شركة الشحن': 'هەڵبژاردنی کۆمپانیای گەیاندن',
  'ادمن الفوترة': 'ئەدمینی پسوولەکردن',
  'ادمن القبض': 'ئەدمینی وەرگرتن',
  'استلام الطلبات الجديدة وتحويلها للكول سنتر': 'وەرگرتنی داواکارییە نوێیەکان و ناردنیان بۆ کۆڵ سەنتەر',
  'الإعدادات': 'ڕێکخستنەکان',
  'التتبّع': 'بەدواداچوون',
  'التجهيز': 'ئامادەکردن',
  'التحصيل (المحصّل)': 'کۆکردنەوەی پارە (کۆکەرەوە)',
  'التوصيل (سائق)': 'گەیاندن (شۆفێر)',
  'الذمم': 'پارەکان',
  'الذمم والمبالغ': 'پارەکان و بڕەکان',
  'الشحن وتعيين السائق': 'گەیاندن و دیاریکردنی شۆفێر',
  'الفوترة': 'پسوولەکردن',
  'القبض وإغلاق الطلب': 'وەرگرتن و داخستنی داواکاری',
  'تأكيد استلام المبلغ': 'دڵنیاکردنەوەی وەرگرتنی پارە',
  'تأكيد القبض وإغلاق الطلب': 'دڵنیاکردنەوەی وەرگرتن و داخستنی داواکاری',
  'تحديث رقم الوصل / حالة الشركة': 'نوێکردنەوەی ژمارەی پسوولە / دۆخی کۆمپانیا',
  'تسديد شركة الشحن': 'پارەدانەوەی کۆمپانیای گەیاندن',
  'تسليم الطلب للسائق': 'ڕادەستکردنی داواکاری بە شۆفێر',
  'تسليم المبلغ للمحصّل': 'ڕادەستکردنی پارە بە کۆکەرەوە',
  'تسليم لشركة الشحن': 'ڕادەستکردن بە کۆمپانیای گەیاندن',
  'تعديل الإعدادات': 'دەستکاریکردنی ڕێکخستنەکان',
  'تعيين سائق': 'دیاریکردنی شۆفێر',
  'تغيير الحالة من صفحة الطلبات': 'گۆڕینی دۆخ لە پەڕەی داواکارییەکانەوە',
  'تغيير موظف الاتصال': 'گۆڕینی فەرمانبەری پەیوەندی',
  'تم التجهيز': 'ئامادە کرا',
  'تم التسليم للزبون': 'ڕادەستی کڕیار کرا',
  'تمت الفوترة': 'پسوولە کرا',
  'حسابي': 'هەژمارەکەم',
  'دخل الطلب للتطبيق': 'داواکارییەکە هاتە ناو ئەپ',
  'دفع أجور شحن': 'پارەدانی کرێی گەیاندن',
  'ذمّتي': 'پارەکانم',
  'رفض الزبون الاستلام': 'کڕیار وەرگرتنی ڕەتکردەوە',
  'رفض الزبون، راجع عبر الشركة': 'کڕیار ڕەتیکردەوە، لە ڕێگەی کۆمپانیاوە دەگەڕێتەوە',
  'زر "ابدأ من الآن"': 'دوگمەی "لە ئێستاوە دەست پێبکە"',
  'سائق': 'شۆفێر',
  'سجل الحركات المالية': 'تۆماری جووڵە داراییەکان',
  'سلّمت الشركة الطلب للزبون': 'کۆمپانیاکە داواکارییەکەی ڕادەستی کڕیار کرد',
  'طلب جديد بمراحله': 'داواکاری نوێ لە قۆناغەکانیدا',
  'طلب متأخر بمراحله': 'داواکاری دواکەوتوو لە قۆناغەکانیدا',
  'كل الطلبات المتأخرة': 'هەموو داواکارییە دواکەوتووەکان',
  'كلمة السر': 'وشەی نهێنی',
  'كول سنتر': 'کۆڵ سەنتەر',
  'كول سنتر (تأكيد الطلبات)': 'کۆڵ سەنتەر (پشتڕاستکردنەوەی داواکارییەکان)',
  'مدير': 'بەڕێوەبەر',
  'مسار الرحلات': 'ڕێگای گەشتەکان',
  'مشاهدة الإعدادات': 'بینینی ڕێکخستنەکان',
  'مشاهدة ذمم الموظفين': 'بینینی پارەی لای فەرمانبەران',
  'مشاهدة كل الطلبات (بدون تعديل)': 'بینینی هەموو داواکارییەکان (بەبێ دەستکاری)',
  'مواقع السائقين المباشرة': 'شوێنی ڕاستەوخۆی شۆفێران',
  'نتيجة الاتصال': 'ئەنجامی پەیوەندی',
  'وصل المرتجع من الشركة': 'گەڕاوەکە لە کۆمپانیاوە گەیشت',
  'يحذف': 'دەسڕێتەوە',
  'يضيف': 'زیاد دەکات',
  'يعدّل': 'دەستکاری دەکات',
  'يعطّل': 'ناچالاک دەکات',

  // ---- Sent by the server (stages, roles, messages) ----
  'طلب وارد': 'داواکاری هاتوو',
  'جاهز للفوترة': 'ئامادەیە بۆ پسوولەکردن',
  'بانتظار التجهيز': 'چاوەڕێی ئامادەکردن',
  'بانتظار تعيين سائق': 'چاوەڕێی دیاریکردنی شۆفێر',
  'بانتظار استلام السائق': 'چاوەڕێی وەرگرتنی شۆفێر',
  'ذمة على السائق': 'پارە لای شۆفێرە',
  'بانتظار تأكيد المحصّل': 'چاوەڕێی پشتڕاستکردنەوەی کۆکەرەوە',
  'ذمة على المحصّل (بانتظار القبض)': 'پارە لای کۆکەرەوەیە (چاوەڕێی وەرگرتن)',
  'ملغي': 'هەڵوەشێنراوە',
  'مرتجع (رُفض الاستلام)': 'گەڕاوە (وەرگرتن ڕەتکرایەوە)',
  'مدير الطلبات': 'بەڕێوەبەری داواکارییەکان',
  'مدير التطبيق': 'بەڕێوەبەری ئەپ',
  'لوجستك (تجهيز + سائقين + تحصيل)': 'لۆجیستیک (ئامادەکردن + شۆفێران + کۆکردنەوە)',
  'مسؤول الشحن': 'بەرپرسی گەیاندن',
  'القبض (الحسابات)': 'وەرگرتن (ژمێریاری)',
  'تم القبض وإغلاق الطلب': 'پارە وەرگیرا و داواکارییەکە داخرا',
  'مرحلة غير معروفة': 'قۆناغێکی نەناسراو',
  'هذا الحساب ليس له دور في تطبيق الطلبات': 'ئەم هەژمارە هیچ ڕۆڵێکی لە ئەپی داواکارییەکاندا نییە',
  'اختر نتيجة الاتصال': 'ئەنجامی پەیوەندی هەڵبژێرە',
  'الإلغاء للمدير أو الكول سنتر فقط': 'هەڵوەشاندنەوە تەنها بۆ بەڕێوەبەر یان کۆڵ سەنتەرە',
  'لا يمكن إلغاء الطلب بعد تسليمه للسائق': 'دوای ڕادەستکردن بە شۆفێر ناتوانرێت داواکارییەکە هەڵبوەشێنرێتەوە',
  'الإرجاع لمرحلة سابقة للمدير فقط': 'گەڕاندنەوە بۆ قۆناغی پێشوو تەنها بۆ بەڕێوەبەرە',
  'لا يمكن إرجاع هذا الطلب لمرحلة سابقة': 'ناتوانرێت ئەم داواکارییە بگەڕێنرێتەوە بۆ قۆناغی پێشوو',
  'إجراء غير معروف': 'کردارێکی نەناسراو',
  'اختر السائق': 'شۆفێر هەڵبژێرە',
  'عيّن سائقاً أولاً': 'سەرەتا شۆفێرێک دیاری بکە',
  'أدخل المبلغ المستلم': 'بڕی پارەی وەرگیراو بنووسە',
  'الدفع للسائقين للمدير أو ادمن القبض فقط': 'پارەدان بە شۆفێران تەنها بۆ بەڕێوەبەر یان ئەدمینی وەرگرتنە',
  'اختر السائق والمبلغ': 'شۆفێر و بڕی پارە هەڵبژێرە',
  'الطلب لم يعد في هذه المرحلة، حدّث الصفحة': 'داواکارییەکە ئیتر لەم قۆناغەدا نییە، پەڕەکە نوێ بکەرەوە',
  'دورك لا يسمح بهذه الخطوة': 'ڕۆڵەکەت ڕێگە بەم هەنگاوە نادات',
  'هذا الطلب معيّن لسائق آخر': 'ئەم داواکارییە بۆ شۆفێرێکی تر دیاریکراوە',
  'الطلب غير موجود في التطبيق': 'داواکارییەکە لە ئەپەکەدا بوونی نییە',
  'هذا الحساب ليس من موظفي التطبيق': 'ئەم هەژمارە لە فەرمانبەرانی ئەپەکە نییە',
  'أدخل الاسم': 'ناو بنووسە',
  'أدخل اسم المستخدم': 'ناوی بەکارهێنەر بنووسە',
  'اسم المستخدم: 3 إلى 32 حرفاً إنكليزياً صغيراً أو أرقاماً أو _ .': 'ناوی بەکارهێنەر: 3 تا 32 پیتی بچووکی ئینگلیزی یان ژمارە یان _ .',
  'اسم المستخدم مستخدم من قبل': 'ئەم ناوی بەکارهێنەرە پێشتر بەکارهاتووە',
  'أدخل كلمة المرور': 'وشەی نهێنی بنووسە',
  'كلمة المرور 8 أحرف على الأقل': 'وشەی نهێنی لانیکەم 8 پیتە',
  'اختر الدور': 'ڕۆڵ هەڵبژێرە',
  'البريد الإلكتروني غير صحيح': 'ئیمەیڵەکە هەڵەیە',
  'البريد الإلكتروني مستخدم من قبل': 'ئەم ئیمەیڵە پێشتر بەکارهاتووە',
  'اسم المستخدم أو كلمة المرور غير صحيحة': 'ناوی بەکارهێنەر یان وشەی نهێنی هەڵەیە',
  'هذا الحساب غير مفعّل في تطبيق الطلبات': 'ئەم هەژمارە لە ئەپی داواکارییەکاندا چالاک نییە',
  'تم تسجيل الخروج': 'چوویتە دەرەوە',
  'سجّل الدخول من جديد': 'دووبارە بچۆ ژوورەوە',
  'ليس لديك صلاحية لهذه الصفحة': 'دەسەڵاتت بۆ ئەم پەڕەیە نییە',
  'صلاحيتك على هذه الصفحة مشاهدة فقط، لا يمكنك التعديل': 'دەسەڵاتت لەسەر ئەم پەڕەیە تەنها بینینە، ناتوانیت دەستکاری بکەیت',
  'ليس لديك صلاحية إلغاء الطلبات': 'دەسەڵاتی هەڵوەشاندنەوەی داواکارییەکانت نییە',
  'ليس لديك صلاحية إرجاع الطلبات لمرحلة سابقة': 'دەسەڵاتی گەڕاندنەوەی داواکارییەکانت بۆ قۆناغی پێشوو نییە',
  'ليس لديك صلاحية إضافة حسابات بهذه الوظيفة': 'دەسەڵاتی زیادکردنی هەژمارت بەم پیشەیە نییە',
  'ليس لديك صلاحية تعديل حسابات هذه الوظيفة': 'دەسەڵاتی دەستکاریکردنی هەژمارەکانی ئەم پیشەیەت نییە',
  'ليس لديك صلاحية تغيير كلمة مرور هذه الوظيفة': 'دەسەڵاتی گۆڕینی وشەی نهێنی ئەم پیشەیەت نییە',
  'ليس لديك صلاحية تعطيل أو تفعيل حسابات هذه الوظيفة': 'دەسەڵاتی ناچالاککردن یان چالاککردنی هەژمارەکانی ئەم پیشەیەت نییە',
  'ليس لديك صلاحية حذف حسابات هذه الوظيفة': 'دەسەڵاتی سڕینەوەی هەژمارەکانی ئەم پیشەیەت نییە',
  'لا يمكنك تغيير وظيفتك أو صلاحياتك أو تعطيل حسابك بنفسك': 'ناتوانیت خۆت پیشە یان دەسەڵاتەکانت بگۆڕیت یان هەژمارەکەت ناچالاک بکەیت',
  'الصلاحيات التفصيلية يحددها مدير التطبيق فقط': 'دەسەڵاتە وردەکان تەنها بەڕێوەبەری ئەپ دیاریان دەکات',
  'لا يمكنك حذف حسابك بنفسك': 'ناتوانیت خۆت هەژمارەکەت بسڕیتەوە',
  'هذا الموظف له طلبات أو مبالغ مسجّلة، لذلك لا يُحذف حتى يبقى السجل صحيحاً. عطّل حسابه بدل الحذف.':
    'ئەم فەرمانبەرە داواکاری یان پارەی تۆمارکراوی هەیە، بۆیە ناسڕدرێتەوە تا تۆمارەکە دروست بمێنێت. لە جیاتی سڕینەوە هەژمارەکەی ناچالاک بکە.',
  'تم حذف الحساب': 'هەژمارەکە سڕایەوە',
  'ليس لديك صلاحية "ابدأ من الآن"': 'دەسەڵاتی "لە ئێستاوە دەست پێبکە"ت نییە',
  'ليس لديك صلاحية تعديل الإعدادات': 'دەسەڵاتی دەستکاریکردنی ڕێکخستنەکانت نییە',
  'اسم المستخدم: 3 إلى 64 حرفاً إنكليزياً صغيراً أو أرقاماً أو . _ - @ (يمكن أن يكون بريداً إلكترونياً)':
    'ناوی بەکارهێنەر: 3 تا 64 پیتی بچووکی ئینگلیزی یان ژمارە یان . _ - @ (دەتوانێت ئیمەیڵ بێت)',
  'ليس لديك صلاحية': 'دەسەڵاتت نییە',
  'التسجيل غير متاح حالياً، تواصل مع الإدارة': 'تۆمارکردن ئێستا بەردەست نییە، پەیوەندی بە بەڕێوەبەرایەتییەوە بکە',
  'طلب تسجيلك قيد المراجعة، تقدر تدخل بعد موافقة الإدارة': 'داواکاری تۆمارکردنەکەت لە پێداچوونەوەدایە، دوای ڕەزامەندی بەڕێوەبەرایەتی دەتوانیت بچیتە ژوورەوە',
  'أدخل رقم الهاتف': 'ژمارەی تەلەفۆن بنووسە',
  'لا يوجد طلب تسجيل بهذا الرقم': 'هیچ داواکارییەکی تۆمارکردن بەم ژمارەیە نییە',
  'اختر وظيفة واحدة على الأقل': 'لانیکەم یەک پیشە هەڵبژێرە',
  'اكتب اسم الزبون': 'ناوی کڕیار بنووسە',
  'اكتب رقم هاتف الزبون': 'ژمارەی تەلەفۆنی کڕیار بنووسە',
  'اكتب عنوان الزبون': 'ناونیشانی کڕیار بنووسە',
  'أضف منتجاً واحداً على الأقل': 'لانیکەم یەک بەرهەم زیاد بکە',
  'المنطقة المختارة غير موجودة في هذه المحافظة': 'ناوچە هەڵبژێردراوەکە لەم پارێزگایەدا نییە',
  'اختر المنطقة، لأن المحافظة مقسّمة لمناطق بأسعار توصيل مختلفة': 'ناوچە هەڵبژێرە، چونکە پارێزگاکە دابەشکراوە بۆ ناوچە بە نرخی گەیاندنی جیاواز',
  'أحد المنتجات لم يعد متوفراً، احذفه من الطلب': 'یەکێک لە بەرهەمەکان ئیتر بەردەست نییە، لە داواکارییەکەی بسڕەوە',
  'هذه المحافظة ليست ضمن محافظاتك': 'ئەم پارێزگایە لە پارێزگاکانی تۆدا نییە',
  'تعذّر حساب الطلب، حاول مرة أخرى': 'ژماردنی داواکارییەکە سەرکەوتوو نەبوو، دووبارە هەوڵبدەرەوە',
  'مع شركة الشحن': 'لای کۆمپانیای گەیاندن',
  'المبلغ عند شركة الشحن': 'پارە لای کۆمپانیای گەیاندنە',
  'راجع عبر شركة الشحن': 'لە ڕێگەی کۆمپانیای گەیاندنەوە دەگەڕێتەوە',
  'أجور شركات الشحن': 'کرێی کۆمپانیاکانی گەیاندن',
  'لا يمكن تغيير طريقة التوصيل في هذه المرحلة': 'لەم قۆناغەدا ناتوانرێت شێوازی گەیاندن بگۆڕدرێت',
  'اختيار شركة الشحن للمدير أو موظف الشحن': 'هەڵبژاردنی کۆمپانیای گەیاندن بۆ بەڕێوەبەر یان فەرمانبەری گەیاندنە',
  'اختر شركة الشحن': 'کۆمپانیای گەیاندن هەڵبژێرە',
  'اختر شركة الشحن أولاً': 'سەرەتا کۆمپانیای گەیاندن هەڵبژێرە',
  'الطلب ليس عند شركة شحن': 'داواکارییەکە لای کۆمپانیای گەیاندن نییە',
  'اكتب رقم الوصل أو حالة الشركة': 'ژمارەی پسوولە یان دۆخی کۆمپانیا بنووسە',
  'أدخل أجرة الإرجاع (0 إذا ما في)': 'کرێی گەڕاندنەوە بنووسە (0 ئەگەر نییە)',
  'الطلب عند شركة الشحن: سجّل "راجع عبر شركة الشحن" بدل الإلغاء': 'داواکارییەکە لای کۆمپانیای گەیاندنە: لە جیاتی هەڵوەشاندنەوە "لە ڕێگەی کۆمپانیاوە دەگەڕێتەوە" تۆمار بکە',
  'تسديد شركات الشحن للمدير أو ادمن القبض فقط': 'پارەدانەوەی کۆمپانیاکانی گەیاندن تەنها بۆ بەڕێوەبەر یان ئەدمینی وەرگرتنە',
  'اختر طلبات التسديد': 'داواکارییەکانی پارەدانەوە هەڵبژێرە',
  'أدخل المبلغ المستلم من الشركة': 'بڕی پارەی وەرگیراو لە کۆمپانیا بنووسە',
  'شركة الشحن غير موجودة أو موقوفة': 'کۆمپانیای گەیاندن بوونی نییە یان ڕاگیراوە',
  'شركة الشحن غير موجودة': 'کۆمپانیای گەیاندن بوونی نییە',
  'اكتب اسم الشركة': 'ناوی کۆمپانیا بنووسە',
  'رابط التتبع يبدأ بـ https://، وضع {code} مكان رقم الوصل': 'بەستەری بەدواداچوون بە https:// دەست پێدەکات، و {code} لە شوێنی ژمارەی پسوولە دابنێ',
  'أضف سعر محافظة واحدة على الأقل، أو اختر سعراً ثابتاً': 'نرخی لانیکەم یەک پارێزگا زیاد بکە، یان نرخێکی جێگیر هەڵبژێرە',
  'أجرة الشركة لا تكون سالبة': 'کرێی کۆمپانیا ناتوانێت سالب بێت',
  'التوصيل بسائقينا': 'گەیاندن بە شۆفێرەکانمان',
  'رد وأكّد': 'وەڵامی دایەوە و پشتڕاستی کردەوە',
  'تحويل لكل موظفي الكول سنتر': 'نێردرا بۆ هەموو فەرمانبەرانی کۆڵ سەنتەر',
  'رفض الزبون الاستلام، راجع عبر الشركة': 'کڕیار وەرگرتنی ڕەتکردەوە، لە ڕێگەی کۆمپانیاوە دەگەڕێتەوە',
};
